import { Box, Card, CardHeader, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import viewCandidateStyles from "../ViewApplicant.styles";
import { Subcontractor } from "../../applicantTypes";
import { isTruthy } from "helpers/methods";
import CustomTable from "global/components/CustomTable/CustomTable";

interface CustomProps {
  candidateData: Subcontractor;
  loader: boolean;
  setLoader: Function;
}

const commentTableHeaders = [
  {
    name: "City",
    field: "city",
    align: "left",
  },
  {
    name: "State",
    field: "state",
    align: "left",
  },
];

const WorkingLocation = (props: CustomProps) => {
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);
  const [formFields, setFormFields] = useState<any>({
    value: props.candidateData?.workingLocation ?? [],
    error: "",
  });

  useEffect(() => {
    isTruthy(props.candidateData!) &&
      setFormFields({
        value: props.candidateData?.workingLocation ?? formFields.value,
        error: "",
      });
  }, [props.candidateData!]);

  const handleRowHover = (index: number) => {
    setHoveredRowIndex(index);
  };

  const handleRowLeave = () => {
    setHoveredRowIndex(null);
  };

  const convertCommentsToTable = (data: any) => {
    return data.map((comment: any, index: number) => {
      return {
        city: (
          <Box sx={viewCandidateStyles.labelText}>
            <Typography sx={viewCandidateStyles.valueText}>
              {comment.city}
            </Typography>
          </Box>
        ),
        state: (
          <Box sx={viewCandidateStyles.labelText}>
            <Typography sx={viewCandidateStyles.valueText}>
              {comment.state}
            </Typography>
          </Box>
        ),
      };
    });
  };

  return (
    <>
      <Card>
        <CardHeader title="Working Location" />
        <Box mt={1}>
          <CustomTable
            headers={commentTableHeaders}
            rows={convertCommentsToTable(formFields.value)}
            showPagination={false}
            onRowHover={handleRowHover}
            onRowLeave={handleRowLeave}
            isLoading={props.loader}
          />
        </Box>
      </Card>
    </>
  );
};

export default WorkingLocation;
